export const temp_sdr_getters = [
    {
        _id: "newsdr_file_status",
        pivot: null,
        valueType: "text",
        key: "status",
        name: "File status",
        name_plural: null
    },
    {
        _id: "newsdr_report_date",
        pivot: null,
        valueType: "date_time",
        key: "reporting_date",
        name: "SDR Report date",
        name_plural: null
    },
    {
        _id: "newsdr_delivery_date",
        pivot: null,
        valueType: "date_time",
        key: "delivery_date",
        name: "SDR Delivery date",
        name_plural: ""
    },
    {
        _id: "newsdr_providers",
        pivot: null,
        valueType: "text",
        key: "providers",
        name: "Providers",
        name_plural: "Providers"
    },
    {
        _id: "newsdr_report_name",
        pivot: null,
        valueType: "text",
        key: "scheduled_report_name",
        name: "Report name",
        name_plural: "Report names"
    },
    {
        _id: "newsdr_file_name",
        pivot: null,
        valueType: "text",
        key: "file_name",
        name: "File name",
        name_plural: "File names"
    },
    {
        _id: "newsdr_report_data_type",
        pivot: null,
        valueType: "text",
        key: "txn_type",
        name: "Report data type",
        name_plural: null
    },
    {
        _id: "newsdr_file_date_type",
        pivot: null,
        valueType: "text",
        key: "file_date_type",
        name: "File date type",
        name_plural: null
    },
    {
        _id: "newsdr_file_size",
        pivot: null,
        valueType: "text",
        key: "filesize",
        name: "File size",
        name_plural: null
    },
    {
        _id: "newsdr_file_size2",
        pivot: null,
        valueType: "text",
        key: "size",
        name: "File size",
        name_plural: null
    },
    {
        _id: "newsdr_delivery_location",
        pivot: null,
        valueType: "text",
        key: "url",
        name: "Delivery location",
        name_plural: null
    },
    {
        _id: "newsdr_subscription_id",
        pivot: null,
        valueType: "text",
        key: "reporting_subscription_ref",
        // eslint-disable-next-line sentence-case/sentence-case
        name: "Subscription ID",
        name_plural: null
    },
    {
        _id: "newsdr_report_id",
        pivot: null,
        valueType: "text",
        key: "report_id",
        // eslint-disable-next-line sentence-case/sentence-case
        name: "Report ID",
        name_plural: null
    },
    {
        _id: "newsdr_report_type",
        pivot: null,
        valueType: "text",
        key: "scheduled_report_name",
        name: "Report type",
        name_plural: null
    },
    {
        _id: "newsdr_upload_log_ref",
        pivot: null,
        valueType: "text",
        key: "upload_log_ref",
        name: "Upload log ID",
        name_plural: null
    },
    {
        _id: "newsdr_upload_date",
        pivot: null,
        valueType: "text",
        key: "upload_date",
        name: "SDR Delivery date",
        name_plural: null
    },
    {
        _id: "newsdr_scheduled_report_ref",
        pivot: null,
        valueType: "text",
        key: "scheduled_report_ref",
        // eslint-disable-next-line sentence-case/sentence-case
        name: "Report ID",
        name_plural: null
    },
    {
        _id: "newsdr_s3_uris",
        pivot: null,
        valueType: "text",
        key: "scheduled_s3_uris",
        name: "File name",
        name_plural: null
    },
    {
        _id: "newsdr_filename",
        pivot: null,
        valueType: "text",
        key: "filename",
        name: "File name",
        name_plural: null
    },
    {
        _id: "newsdr_avail_sdrs",
        pivot: null,
        valueType: "text",
        key: "provider_report_names",
        // eslint-disable-next-line sentence-case/sentence-case
        name: "Available SDRs",
        name_plural: null
    },
    {
        _id: "newsdr_filename_format",
        pivot: null,
        valueType: "text",
        key: "filename_format",
        name: "Filename format",
        name_plural: null
    },
    {
        _id: "newsdr_filename",
        pivot: null,
        valueType: "text",
        key: "filename",
        name: "File name",
        name_plural: null
    },
    {
        _id: "newsdr_sub_status",
        pivot: null,
        valueType: "text",
        key: "active",
        name: "Status",
        name_plural: null
    }
];
